import { TableRow, TableCell, Box, Typography } from '@mui/material';
import { MapRankCss } from './MapRankCss';
import { openNewTab } from 'src/common/config/FunctionHelper';
export const ResultModalRow = ({ row, index }) => {
  return (
    <TableRow hover>
      {/* Rank */}
      <TableCell>
        <Typography sx={MapRankCss?.modalRowNum}> {index + 1}</Typography>
      </TableCell>

      {/* Business Name + Address */}
      <TableCell>
        <Box sx={MapRankCss?.newWindowBoxSx}>
          <Typography sx={MapRankCss?.modalRowName}>
            {row?.title || '-'}
          </Typography>
          {row?.profile_url && (
            <img
              onClick={() => {
                openNewTab(row?.profile_url);
              }}
              className="cursor-pointer"
              draggable={false}
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/shareSquareIcon.svg`
              }
              width={16}
              height={16}
            />
          )}
        </Box>
      </TableCell>

      {/* Found In */}
      <TableCell>
        <Typography sx={MapRankCss?.modalRowComSx}>
          {row?.num_reviews || '-'}
        </Typography>
      </TableCell>

      {/* Visibility */}
      <TableCell>
        <Typography sx={MapRankCss?.modalRowComSx}>
          {row?.review_rating || '-'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
